module.exports = __webpack_public_path__ + "static/img/dsxt3.5f16373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/dsxt3.jpg
// module id = 309
// module chunks = 34